export default __webpack_public_path__ + "static/media/sideBySide.ed7b0719.webp";